import type { Video } from 'js/src/client';

export function getTabDurationsFromVideo(video: Video) {
    let media_tab_duration = video.media_tab_duration;
    if (!media_tab_duration || media_tab_duration <= 0) {
        media_tab_duration = 0;
    }
    let music_tab_duration = video.music_tab_duration;
    if (!music_tab_duration || music_tab_duration <= 0) {
        music_tab_duration = 0;
    }
    let style_tab_duration = video.style_tab_duration;
    if (!style_tab_duration || style_tab_duration <= 0) {
        style_tab_duration = 0;
    }
    let format_tab_duration = video.format_tab_duration;
    if (!format_tab_duration || format_tab_duration <= 0) {
        format_tab_duration = 0;
    }
    let icons_tab_duration = video.icons_tab_duration;
    if (!icons_tab_duration || icons_tab_duration <= 0) {
        icons_tab_duration = 0;
    }
    let voiceover_tab_duration = video.voiceover_tab_duration;
    if (!voiceover_tab_duration || voiceover_tab_duration <= 0) {
        voiceover_tab_duration = 0;
    }
    let original_content_tab_duration = video.original_content_tab_duration;
    if (!original_content_tab_duration || original_content_tab_duration <= 0) {
        original_content_tab_duration = 0;
    }

    return {
        media: media_tab_duration,
        music: music_tab_duration,
        style: style_tab_duration,
        format: format_tab_duration,
        icons: icons_tab_duration,
        voiceover: voiceover_tab_duration,
        original_content: original_content_tab_duration,
    };
}
